module.exports = __webpack_public_path__ + "img/LC.8d00c9e0.svg";